import "./sentry";

import { saveAttributionIfPresent } from "./lib/attribution";
saveAttributionIfPresent();

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";

import "./index.css"; // ✅ THIS is what restores Tailwind/global styling

import App from "./App.jsx";

import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

import { initAnalytics } from "./lib/analytics";

// ✅ PWA registration (vite-plugin-pwa)
import { registerSW } from "virtual:pwa-register";
import { HelmetProvider } from "react-helmet-async";
registerSW({
  immediate: true,
  onNeedRefresh() {
    // einfaldasti “no drama” kosturinn:
    window.location.reload();
  },
});

initAnalytics();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
